<template>
	<div class="forgot-password-form">
		<router-link :to="{ name: 'home' }" class="lineup-home">
			<img class="logo-lineup" src="../assets/logos/mate/lineup-black.svg" alt="LineUp Tickets">
		</router-link>
		<span class="forgot-password-title">Restablecer contraseña</span>
		<div class="input-group" :class="{ 'form-group--error': $v.password.$error }">
			<label class="form__label" for="password">Nueva contraseña</label>
			<input class="form__input" type="password" id="password" name="password" v-model="password" v-on:keyup.enter="onSubmit" :class="{ 'form-input--error': $v.password.$error }" @keydown.space.prevent v-if="!showPassword">
			<input class="form__input" type="text" id="password" name="password" v-model="password" v-on:keyup.enter="onSubmit" :class="{ 'form-input--error': $v.password.$error }" @keydown.space.prevent v-else>
			<i class='bx bx-show input-icon' @click="showPassword = !showPassword" v-if="showPassword"></i>
			<i class='bx bx-hide input-icon' @click="showPassword = !showPassword" v-else></i>
		</div>
		<div class="error-group" v-if="$v.password.$dirty">
			<div class="error" v-if="!$v.password.required">Ingresa tu nueva contraseña.</div>
			<div
				class="error"
				v-else-if="
					!$v.password.minLength ||
					!$v.password.maxLength ||
					!$v.password.containsChar ||
					!$v.password.containsNum
				"
			>
				Debe contener al menos 8 caracteres y debe incluir al menos una letra y
				un número.
			</div>
		</div>

		<div class="input-group" :class="{ 'form-group--error': $v.passwordRepeat.$error }">
			<label class="form__label" for="passwordRepeat">Repite la nueva contraseña</label>
			<input class="form__input" type="password" id="passwordRepeat" name="passwordRepeat" v-model="passwordRepeat" v-on:keyup.enter="onSubmit" :class="{ 'form-input--error': $v.passwordRepeat.$error }" @keydown.space.prevent v-if="!showPassword">
			<input class="form__input" type="text" id="password" name="password" v-model="passwordRepeat" v-on:keyup.enter="onSubmit" :class="{ 'form-input--error': $v.passwordRepeat.$error }" @keydown.space.prevent v-else>
		</div>
		<div class="error-group" v-if="$v.passwordRepeat.$dirty">
			<div class="error" v-if="!$v.passwordRepeat.required">Repite tu nueva contraseña.</div>
			<div class="error" v-else-if="!$v.passwordRepeat.sameAs">Contraseñas no coinciden.</div>
		</div>

		<div class="error-area" v-if="forgotPasswordError">
			<span>{{ forgotPasswordError }}</span>
		</div>
		<button @click.prevent="onSubmit" :disabled="submitingForm" v-if="!submitingForm">Restablecer contraseña</button>
		<button disabled="disabled" v-if="submitingForm">
			Restablecer contraseña <clip-loader class="forgot-password-loader" :color="'var(--color-darker)'" :size="'12px'" ></clip-loader>
		</button>
		<router-link :to="{ name: 'login' }"><i class='bx bx-arrow-back'></i>Volver al inicio de sesión.</router-link>
	</div>
</template>

<script>
	import axios from 'axios'

	import { required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return {
				password: '',
				passwordRepeat: '',
				showPassword: false,
				forgotPasswordError: null,
				submitingForm: false,
			}
		},
		components: {
			ClipLoader
		},
		metaInfo: {
			title: 'Olvidé mi contraseña',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		validations: {
			password: {
				required,
				minLength: minLength(8),
				maxLength: maxLength(50),
				containsChar: function(value){
					return /[a-zA-Z]/.test(value)
				},
				containsNum: function(value){
					return /[0-9]/.test(value)
				}
			},
			passwordRepeat: {
				required,
				sameAs: sameAs('password')
			}
		},
		async mounted(){
			this.$store.dispatch("AuthModule/updateCallbackAction", {
				callbackAction: {
					name: "AuthModule/redirigirA",
					payload: {
						route: "home",
						params: {},
					},
				},
			});

			await this.validarCodigo();
		},
		methods: {
			async onSubmit(){
				this.$v.$touch();

				if(!this.$v.$invalid){
					this.submitingForm = true
					this.forgotPasswordError = null;

					try {
						let response = await axios.post('/WSPasswordRestablecer', {
							ActivacionGUID: this.$route.params.hash,
							NewUsuarioPassword: this.password
						});

						if(response.data.ErrorCod === 0){
							this.$store.dispatch('showSuccess', 'Contraseña cambiada exitosamente.')
							this.$router.push({ name: 'login' })
						} else {
							this.forgotPasswordError = response.data.ErrorDsc
						}

						this.submitingForm = false
					} catch (error) {
						this.submitingForm = false
						this.$store.dispatch('showError', 'Ocurrió un error, intenta nuevamente.')
						this.$router.push({ name: 'login' })
					}
				}
			},
			async validarCodigo(){
				try{
					let response = await axios.post('/WSPasswordRestablecerValidar', { 
						ActivacionGUID: this.$route.params.hash
					});

					if (response.data.ErrorCod !== 0){
						this.$store.dispatch('showError', response.data.ErrorDsc)
						this.$router.push({ name: 'login' });
					}
				} catch (error){
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'login' })
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.forgot-password-form{
		width: 100%;
		padding: 0px;
		@include flex(column, center, flex-start);

		.lineup-home{
			display: none;
			text-decoration: none;
			cursor: pointer;
			margin-bottom: 20px;

			.logo-lineup{
				height: 42px;
				width: auto;
			}
		}

		.forgot-password-title{
			font-family: var(--font-sora);
			font-weight: var(--fw-700);
			font-size: 26px;
			margin-bottom: 7px;
		}

		.forgot-password-subtitle{
			font-weight: var(--fw-400);
			font-size: 14px;
			margin-bottom: 15px;
			line-height: 1.6em;
		}
		
		.input-row{
			width: 100%;
			margin: 0px;
			@include flex(row, space-between, flex-start);

			.input-group-wrapper{
				width: 100%;
				margin: 0px;
				padding: 0px;
				position: relative;
				@include flex(column, center, flex-start);

				&.input-group-wrapper-50{
					width: calc(50% - 8px);
				}
			}
		}

		.input-group{
			width: 100%;
			margin: 8px 0px 4px 0px;
			position: relative;
			@include flex(column, flex-end, flex-start);

			label{
				font-size: 13px;
				font-weight: var(--fw-600);
				margin-top: 0px;
				margin-bottom: 6px;
				line-height: 1em;
			}

			input{
				-webkit-appearance: none;
				appearance: none;
				border: none;
				width: 100%;
				padding: 0px 36px 0px 14px;
				font-size: 14px;
				font-weight: var(--fw-400);
				line-height: 1.4em;
				width: 100%;
				border-radius: 8px;
				height: 44px;
				outline: none;
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
				// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

				&::placeholder {
					color: #9aa5b5;
					opacity: 1;
				}

				&:-ms-input-placeholder {
					color: #9aa5b5;
				}

				&::-ms-input-placeholder {
					color: #9aa5b5;
				}

				&:focus-within {
					@include transition(all .2s);
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset;

					&.form-input--error{
						box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
					}
				}

				&.form-input--error{
					box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
				}
			}

			input:-webkit-autofill,
			input:-webkit-autofill:hover, 
			input:-webkit-autofill:focus,
			textarea:-webkit-autofill,
			textarea:-webkit-autofill:hover,
			textarea:-webkit-autofill:focus,
			select:-webkit-autofill,
			select:-webkit-autofill:hover,
			select:-webkit-autofill:focus {
				border: none;
				-webkit-text-fill-color: var(--color-darker);
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px var(--color-white) inset;
				-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px var(--color-white) inset;

				&:focus-within {
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset, 0 0 0px 1000px var(--color-white) inset;
				}
			}

			.input-icon{
				position: absolute;
				color: rgb(176, 176, 176);
				bottom: 12px;
				font-size: 20px;
				right: 12px;
				cursor: pointer;

				&:hover{
					@include transition(all .2s);
					color: var(--color-darker);
				}
			}

			&.form-group--error{
				label{
					color: var(--color-red-error);
				}
			}

			&.forgot-password{
				@include flex(row, flex-end, center);

				span{
					font-size: 11px;
					text-align: right;
					color: var(--color-darker);
					font-weight: var(--fw-600);
					@include transition(all .2s);
					cursor: pointer;

					&:hover{
						text-decoration: underline;
					}
				}
			}
		}

		.error-group{
			width: 100%;
			@include flex(column, center, flex-start);

			.error{
				font-size: 11px;
				color: var(--color-red-error);
				line-height: 1em;
			}
		}

		button{
			background-color: #222222;
			border: none;
			border-radius: 8px;
			outline: none;
			padding: 14px;
			width: 100%;
			color: var(--color-white);
			font-size: 15px;
			font-weight: var(--fw-600);
			font-family: var(--font-sora);
			line-height: 1.4em;
			letter-spacing: 1px;
			margin-top: 14px;
			@include transition(all .2s);
			cursor: pointer;
			@include flex(row, center, center);

			&:hover{
				background-color: var(--color-black);
			}

			&:disabled {
				background-color: #e8e9eb;
				color: var(--color-darker);
				border-color: #e8e9eb;
				cursor: not-allowed;
			}
		}

		.forgot-password-loader{
			margin-left: 10px;
			margin-bottom: -3px;
		}

		.error-area{
			width: 100%;
			@include flex(row, flex-start, center);
			padding: 12px;
			margin-top: 10px;
			border-radius: 8px;
			background: rgb(255, 243, 243);

			span{
				color: rgb(242, 53, 53);
				font-size: 14px;
				font-weight: var(--fw-500);
			}
		}

		a{
			font-weight: var(--fw-600);
			font-size: 13px;
			text-align: center;
			width: auto;
			margin-top: 15px;
			color: var(--color-darker);
			cursor: pointer;
			text-decoration: underline;

			i{
				font-size: 12px;
				margin-right: 4px;
			}
		}
	}

	@media screen and (max-width: 968px){
		.forgot-password-form{
			.lineup-home{
				@include flex(row, flex-start, center);
			}
		}
	}

	@media screen and (max-width: 450px){
		.forgot-password-form{
			.forgot-password-title{
				font-size: 22px;
			}
		}
	}

	@media screen and (max-height: 810px){
		.forgot-password-form{
			.forgot-password-title{
				font-size: 22px;
			}

			.input-group{
				margin: 4px 0px 3px 0px;

				label {
					font-size: 12px;
					margin-bottom: 4px;
				}

				input{
					height: 40px;
					font-size: 13px;
				}
			}

			button{
				margin-top: 10px;
				font-size: 14px;
				padding: 12px;
			}
		}
	}
</style>